import { formatV2SearchParams } from '../../../../config/research/v2';
import { getExecutionViews } from '../execution.utils';
import type { GetExecutionRequest } from '../models';
import { GetExecutionResponse, GetExecutionResponseV2 } from '../models';

const mapExecutionV2ToV1 = ({ metadata, data, total }: GetExecutionResponseV2): GetExecutionResponse => {
    const execution = metadata?.execution;

    return {
        data: {
            rows: data,
            id: String(execution.id ?? ''),
            executionId: String(execution.execution_id ?? ''),
            userId: String(execution.user_id ?? ''),
            userEmail: '',
            queryId: String(execution.query_id ?? ''),
            state: execution.state,
            metadata: {
                ...execution?.metadata,
                ...getExecutionViews(data, execution),
                totalRowsFound: total,
            },
            error: execution.error,
            executionEndedAt: String(execution.execution_ended_at),
            executionStartedAt: String(execution.execution_started_at),
            expiresAt: String(execution.expires_at ?? ''),
            createdAt: String(execution.created_at ?? ''),
            updatedAt: String(execution.updated_at ?? ''),
        },
        _meta: {
            total,
            success: true,
        },
    };
};

const mapExecutionParamsV2ToV1 = ({ limit = 50 * 1000, page = 1, order, filter }: Partial<GetExecutionRequest>) => {
    let orderBy, orderDir;

    if (order) {
        const [by, dir] = order.split(',');
        if (by) orderBy = by;
        if (dir) orderDir = dir;
    }

    return formatV2SearchParams({
        limit,
        page,
        order_by: orderBy,
        order_dir: orderDir,
        search: filter,
    });
};

export { mapExecutionParamsV2ToV1, mapExecutionV2ToV1 };
